import CropVariableForm from "components/agro/cropVariables/CropVariableForm";

const CropVariableCreateForm = ({ onSuccess }) => {
  const defaultState = {
    name: "",
    measurementUnit: "",
  };

  async function onSubmit(valuesParam) {
    if (onSuccess) onSuccess();
  }

  return (
    <div>
      <CropVariableForm onSubmit={onSubmit} initialValues={defaultState} />
    </div>
  );
};

export default CropVariableCreateForm;
